import store from './store';

export function getData({ data }) {
  return data;
}

export function useToken(config) {
  if (store.state.token) config.headers.Authorization = `Bearer ${store.state.token}`;
  return config;
}